export default "__VITE_PUBLIC_ASSET__4c1a7de1__"